document.addEventListener("DOMContentLoaded", function () {
  // Find Tepō container
  var tepoContainer = document.querySelector(
    '[id^="tcustomizer-form-container"]',
  );

  // Check if Tepō options are active (has children)
  var hasTepoOptions = tepoContainer && tepoContainer.children.length > 0;

  if (hasTepoOptions) {
    console.log("✅ I have Tepō options on this product.");
  } else {
    console.log("❌ I do NOT have Tepō options on this product.");

    // Direct checkout implementation for products WITHOUT Tepō options
    var addToCartBtn = document.querySelector(
      'form[action^="/cart"] [type="submit"]',
    );

    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", function (e) {
        e.preventDefault();

        var form = addToCartBtn.closest("form");
        var formData = new FormData(form);

        // If variant ID is missing, add the first available variant manually
        if (!formData.has("id")) {
          // Retrieve from global Shopify object
          var variantId = null;

          if (
            typeof window.meta !== "undefined" &&
            window.meta.product &&
            window.meta.product.variants
          ) {
            variantId = window.meta.product.variants[0].id;
          } else if (
            window.Shopify &&
            Shopify.product &&
            Shopify.product.variants
          ) {
            variantId = Shopify.product.variants[0].id;
          }

          if (variantId) {
            formData.append("id", variantId);
          } else {
            console.error("⚠️ Could not find variant ID for this product.");
            return;
          }
        }

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then(function (response) {
            if (response.ok) {
              window.location.href = "/cart";
            } else {
              response.json().then(function (data) {
                console.error("Add to cart failed:", data);
                alert(data.description || "Failed to add product to cart.");
              });
            }
          })
          .catch(function (error) {
            console.error("Fetch error:", error);
            alert("An error occurred while adding to cart.");
          });
      });
    }
  }
});
